const initialState = {
  isAddingConstructionOrder: false,
  constructionOrderList: [],
  isFetchingConstructionOrder: false,
  constructionOrderDataList: [],
  isFetchingConstructionOrderWithId: false,
  constructionOrderWithIdData: [],
};

const ConstructionOrderReducer = (state = initialState, action) => {
  switch (action.type) {

    case "REQUEST_ADD_CONSTRUCTION_ORDER":
      return { ...state, isAddingConstructionOrder: true };
    case "SUCCESS_ADD_CONSTRUCTION_ORDER":
      return { ...state, constructionOrderList: action.payload, isAddingConstructionOrder: false, };
    case "ERROR_ADD_CONSTRUCTION_ORDER":
      return { ...state, isAddingConstructionOrder: false };


    case "REQUEST_GET_CONSTRUCTION_ORDER":
      return { ...state, isFetchingConstructionOrder: true };
    case "SUCCESS_GET_CONSTRUCTION_ORDER":
      return { ...state, constructionOrderDataList: action.payload.data, isFetchingConstructionOrder: false };
    case "ERROR_GET_CONSTRUCTION_ORDER":
      return { ...state, isFetchingConstructionOrder: false };


    case "REQUEST_GET_CONSTRUCTION_ORDER_WITH_ID":
      return { ...state, isFetchingConstructionOrderWithId: true };
    case "SUCCESS_GET_CONSTRUCTION_ORDER_WITH_ID":
      return { ...state, constructionOrderWithIdData: action.payload.data, isFetchingConstructionOrderWithId: false };
    case "ERROR_GET_CONSTRUCTION_ORDER_WITH_ID":
      return { ...state, isFetchingConstructionOrderWithId: false };


    case "RESET_CONSTRUCTION_ORDER_DATA":
      return { ...state, constructionOrderWithIdData: {} };


    default:
      return state;
  }
};
export default ConstructionOrderReducer;
